import { render, staticRenderFns } from "./o-section-offset.vue?vue&type=template&id=46fe504c&scoped=true"
import script from "./o-section-offset.vue?vue&type=script&lang=js"
export * from "./o-section-offset.vue?vue&type=script&lang=js"
import style0 from "./o-section-offset.vue?vue&type=style&index=0&id=46fe504c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe504c",
  null
  
)

export default component.exports